import { Layout, Menu, Select, Tabs } from 'antd';
import React from 'react';
import { useIsMobile } from '@/hooks/useIsMobile';

const { Sider, Content } = Layout;

export type SectionNavItem = {
  key: string;
  label: React.ReactNode;
};

type Props = {
  items: SectionNavItem[];
  activeKey: string;
  onChange: (key: string) => void;
  children: React.ReactNode;
  /** 桌面侧栏宽度 */
  siderWidth?: number;
};

/**
 * 详情页分区导航：桌面左侧菜单，移动端顶部 Tabs + 下拉兜底。
 */
const SectionNavLayout: React.FC<Props> = ({
  items,
  activeKey,
  onChange,
  children,
  siderWidth = 180,
}) => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <div
        style={{
          background: '#fff',
          borderRadius: 8,
          border: '1px solid rgba(5,5,5,0.06)',
          overflow: 'hidden',
        }}
      >
        <div
          style={{
            padding: '8px 12px 0',
            borderBottom: '1px solid rgba(5,5,5,0.06)',
            background: '#fafafa',
          }}
        >
          {items.length > 5 ? (
            <Select
              value={activeKey}
              onChange={onChange}
              options={items.map((i) => ({
                value: i.key,
                label: i.label,
              }))}
              style={{ width: '100%', marginBottom: 8 }}
              size="large"
            />
          ) : (
            <Tabs
              activeKey={activeKey}
              onChange={onChange}
              size="small"
              tabBarGutter={12}
              items={items.map((i) => ({
                key: i.key,
                label: i.label,
              }))}
              tabBarStyle={{ marginBottom: 0 }}
              className="section-nav-tabs"
              style={{ marginBottom: 0 }}
            />
          )}
        </div>
        <div style={{ padding: 12 }}>{children}</div>
      </div>
    );
  }

  return (
    <Layout
      style={{
        background: '#fff',
        borderRadius: 8,
        minHeight: 480,
        border: '1px solid rgba(5,5,5,0.06)',
        overflow: 'hidden',
      }}
    >
      <Sider
        width={siderWidth}
        theme="light"
        style={{
          background: '#fff',
          borderRight: '1px solid rgba(5,5,5,0.06)',
        }}
      >
        <Menu
          mode="inline"
          selectedKeys={[activeKey]}
          items={items}
          onClick={({ key }) => onChange(key)}
          style={{
            borderInlineEnd: 'none',
            paddingTop: 8,
            background: '#fff',
          }}
        />
      </Sider>
      <Content style={{ padding: 24, background: '#fff' }}>{children}</Content>
    </Layout>
  );
};

export default SectionNavLayout;
